const SvgArrowBack = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 37 32">
    <path d="m15.241.762 1.076 1.076L2.916 15.236l33.652-.062.003 1.521-33.662.062 13.408 13.405-1.076 1.076L0 16z" />
  </svg>;
export default SvgArrowBack;